import type { useChatAppointmentsQuery$data } from "@/modules/chats/services/__generated__/useChatAppointmentsQuery.graphql"
import type { ExtractNode } from "@/modules/patients/types/ExtractNode"
import type { Language, Service } from "@/types/__generated__/union-types"

export type ChatPatient = ExtractNode<useChatAppointmentsQuery$data["chatsTakenByMe"]>["patient"]

export interface ChatAutoTranslationSetting {
  isLiveTranslationEnabled: boolean
  targetAgentLanguage: Language
}

export const getAutoTranslationTargetLanguage = (thread: ChatThread): Language | undefined =>
  thread.autoTranslationSetting?.isLiveTranslationEnabled
    ? thread.autoTranslationSetting.targetAgentLanguage
    : undefined

export interface ChatThread {
  id: string
  appointmentId: string
  appointmentService: Service
  language: Language
  isMedicalChat: boolean
  patient: ChatPatient
  questionnaireId: number | null
  greetingMessageReceived: boolean
  autoTranslationSetting: ChatAutoTranslationSetting | null
}

export const UNREAD_MESSAGE_THRESHOLD = 99
